"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Spinner: true,
  LoadingPage: true,
  AbsoluteCentered: true,
  ErrorMsg: true,
  AuthSwitch: true
};
exports.AbsoluteCentered = AbsoluteCentered;
exports.AuthSwitch = AuthSwitch;
exports.ErrorMsg = void 0;
exports.LoadingPage = LoadingPage;
exports.Spinner = Spinner;

var _react = _interopRequireDefault(require("react"));

var _firebase = require("./firebase");

var _logoSpinning = _interopRequireDefault(require("../assets/logoSpinning.svg"));

var _LoginSignup = _interopRequireDefault(require("./Login/LoginSignup"));

var _ManageAccount = require("./Login/ManageAccount");

Object.keys(_ManageAccount).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ManageAccount[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ManageAccount[key];
    }
  });
});

var _User = require("./Login/User");

Object.keys(_User).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _User[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _User[key];
    }
  });
});

var _Media = require("./Media/Media");

Object.keys(_Media).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Media[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Media[key];
    }
  });
});

var _DBResouceContext = require("./Media/DBResouceContext");

Object.keys(_DBResouceContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DBResouceContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DBResouceContext[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Spinner(props) {
  return /*#__PURE__*/_react.default.createElement("img", _extends({
    src: _logoSpinning.default
  }, props));
}

function LoadingPage(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, props.title && /*#__PURE__*/_react.default.createElement("h4", null, props.title), props.description && /*#__PURE__*/_react.default.createElement("p", null, props.description), /*#__PURE__*/_react.default.createElement(Spinner, {
    style: {
      width: '80%',
      maxWidth: '500px',
      margin: '20% auto'
    }
  }));
}

function AbsoluteCentered(props) {
  var child = _react.default.Children.only(props.children);

  return /*#__PURE__*/_react.default.cloneElement(props.children, {
    style: _objectSpread(_objectSpread({
      position: 'absolute',
      margin: 0,
      top: '50%',
      left: '50%',
      transform: 'translateY(-50%) translateX(-50%)'
    }, child.props.style), props.style)
  });
}

var ErrorMsg = function ErrorMsg(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center p-5"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://www.biblestudytools.com/Content/Images/file-not-found.jpg",
    className: "mw-100"
  }), /*#__PURE__*/_react.default.createElement("h3", null, "Oops, we broke something...", /*#__PURE__*/_react.default.createElement("br", null), "Try ", /*#__PURE__*/_react.default.createElement("a", {
    href: "/"
  }, "refreshing the page"), "or email ", /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:rose@bythebookthebible.com"
  }, "rose@bythebookthebible.com")));
};

exports.ErrorMsg = ErrorMsg;

function AuthSwitch(props) {
  // const rehydrated = useSelector(state => state._persist.rehydrated)
  var user = (0, _firebase.useAuth)();
  console.log({
    user: user
  }); // login / loading cases

  if (!user) return /*#__PURE__*/_react.default.createElement(_LoginSignup.default, null); // not logged in

  if (!user.profile) return /*#__PURE__*/_react.default.createElement(LoadingPage, {
    title: "Loading Profile..."
  }); // loading profile (and claims)
  // if(!user.online) return props.children // offline mode assumes you have a valid account

  if (!(user.profile.updatedSubscription || user.profile.freePartner)) return /*#__PURE__*/_react.default.createElement(Subscribe, null);
  return props.children; // if(!user.claims?.stripeId) {
  //   // account is not initialized yet on the back end
  //   // let firebase initialize (wait or trigger)
  //   return <LoadingPage title="Preparing Account..."/>
  // }
  // if(user.claims.admin || user.claims.permanentAccess || user.claims.expirationDate - Date.now() > 0) {
  //   return props.children // logged in successfully
  // }
  // check stripe status:
  // if there is no subscription (and we already checked the trial is expired)
  // return <Subscribe />
  // if there is a subscription that has been canceled or has an error or something, prompt accordingly
}